import { Component, Input, AfterViewInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import Quill from 'quill';

@Component({
  selector: 'app-rich-text-editor',
  templateUrl: './rich-text-editor.component.html',
  styleUrls: ['./rich-text-editor.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RichTextEditorComponent),
      multi: true
    }
  ]
})
export class RichTextEditorComponent implements AfterViewInit, ControlValueAccessor {
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() isSubmitted: boolean = false;
  @Input() required: boolean = false;
  @Input() maxLength: number = 5000;

  editorModules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote', 'code-block'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],
      [{ 'direction': 'rtl' }],
      [{ 'align': [] }],
      ['link'],
      ['clean']
    ],
    keyboard: {
      bindings: {
        tab: 'indent',
        shiftTab: 'outdent'
      }
    }
  };

  quillEditor: any;
  value: string = '';

  // ControlValueAccessor implementation
  onChange: (value: string) => void = () => {};
  onTouched: () => void = () => {};

  ngAfterViewInit() {
    // Quill will be initialized by ngx-quill
  }

  onEditorCreated(quill: any) {
    this.quillEditor = quill;
    // Set the initial value if it exists
    if (this.value) {
      this.quillEditor.root.innerHTML = this.value;
    }
  }

  writeValue(value: string): void {
    this.value = value || '';
    if (this.quillEditor) {
      this.quillEditor.root.innerHTML = this.value;
    }
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  onContentChanged(event: any) {
    const html = event.html;
    this.value = html;
    this.onChange(html);
  }
}
